import { useAppSelector } from "../../../../ReduxToolkit/Hooks";
import Chat from "../PrivateChat.tsx/Chat";
import ChatHeader from "../PrivateChat.tsx/ChatHeader";
import MessageInput from "../PrivateChat.tsx/MessageInput";

const GroupChat = () => {
  const { subChatActiveTab } = useAppSelector((state) => state.messenger);

  return (
    <div className={`messages custom-scroll ${subChatActiveTab === "group" ? "active" : ""}`} id="group_chat">
      <ChatHeader />
      <Chat />
      <MessageInput />
    </div>
  );
};

export default GroupChat;
